import Typography from "@mui/material/Typography";
import React from 'react';
import { ResetMobilePassword, ResetMobilePasswordHeader, ResetMobilePasswordText } from "./Theme";

const ResetMobilePasswordModal = ({generateNewPassword,closeModal,isLoading}) => {

  



  return (
    <>
      <ResetMobilePassword>
        <ResetMobilePasswordHeader>
          <Typography variant="h5" gutterBottom>
            Mobile App Password
          </Typography>
          <ResetMobilePasswordText>Press “Send” to generate a new password and email it.</ResetMobilePasswordText>
        </ResetMobilePasswordHeader>
        <div className="update__user__header">
          <div className="user__header__action add-event-type-page__actions">
            <button
              className="cancel_user_btn"
              onClick={closeModal}
            >
              Cancel
            </button>
            <button
              className="save_user_btn btn btn-primary"
              onClick={generateNewPassword}
              disabled={isLoading}
            >
              <span className="user_btn_text">Send</span>
              {isLoading && (
                <span className="ml-3 spinner spinner-white"></span>
              )}
            </button>
          </div>
        </div>
      </ResetMobilePassword>
    </>
  )
}

export default ResetMobilePasswordModal